import React from "react";
import { LogoSvgImg } from "./svgFiles";
import {
  aboutFooterSection,
  businessFooterSection,
  socials,
} from "../utils/data";
import Image from "next/image";
import Link from "next/link";
import { EnvelopeIcon, MapPinIcon } from "@heroicons/react/24/outline";

const Footer = () => {
  return (
    <>
      <div className="px-5 md:px-[4rem] xl:px-[6rem] pt-[6rem] pb-[3rem] bg-black text-white">
        <div className="grid grid-cols-5 gap-8">
          <div className="col-span-5 xl:col-span-1">
            <div className="flex flex-col items-center sm:items-start gap-2">
              <LogoSvgImg className="w-[135px]" />
              <p className="text-[17px] font-[500]">info@acqmangers.com</p>
              <div className="flex items-center gap-1">
                {socials.map((social, index) => {
                  const { img, label, link } = social;
                  return (
                    <Link
                      href={link}
                      key={index}
                      className="bg-[#343538] p-[0.6rem] rounded-full"
                    >
                      <Image
                        src={img}
                        alt={label}
                        width={300}
                        height={300}
                        className="w-[18px] h-[18px]"
                      />
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-span-5 xl:col-span-4">
            <div className="grid grid-cols-3 gap-[2.5rem] md:gap-0">
              <div className="col-span-3 md:col-span-1 flex flex-col items-center sm:items-start gap-3">
                {aboutFooterSection.map((item, index) => {
                  const { type, content } = item;
                  if (item.type === "heading") {
                    return (
                      <h2 key={index} className="text-[20px] font-bold">
                        {content}
                      </h2>
                    );
                  } else if (type === "link") {
                    return (
                      <Link
                        key={index}
                        href={item.href}
                        className="text-[16.5px] font-medium hover:text-primaryColor hover:font-[600]"
                      >
                        {item.text}
                      </Link>
                    );
                  }
                  return null;
                })}
              </div>
              <div className="col-span-3 md:col-span-1 flex flex-col items-center sm:items-start gap-3">
                {businessFooterSection.map((item, index) => {
                  const { type, content } = item;
                  if (item.type === "heading") {
                    return (
                      <h2 key={index} className="text-[20px] font-bold">
                        {content}
                      </h2>
                    );
                  } else if (type === "link") {
                    return (
                      <Link
                        key={index}
                        href={item.href}
                        className="text-[16.5px] font-medium hover:text-primaryColor hover:font-[600]"
                      >
                        {item.text}
                      </Link>
                    );
                  }
                  return null;
                })}
              </div>

              <div className="col-span-3 w-full md:col-span-1 flex flex-col items-center sm:items-start gap-3">
                <h2 className="text-[20px] font-bold">Contact Us</h2>
                <div className="flex gap-3">
                  <div className="bg-[#343538] rounded-full p-3 w-fit h-fit hidden md:block">
                    <MapPinIcon className="w-5" />
                  </div>
                  <div className="text-[16.5px] text-center sm:text-left font-medium leading-[1.6rem]">
                    Plot 1062 B Abagbon Close, <br /> Off Ologun Agbaje Street,
                    Victoria Island, Lagos, Nigeria
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-[#343538] rounded-full p-3 w-fit h-fit hidden md:block">
                    <EnvelopeIcon className="w-5" />
                  </div>
                  <Link
                    href="#"
                    className="text-[16px] -mt-1 font-medium hover:text-primaryColor hover:underline"
                  >
                    info@acqmanagers.com
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center text-[14px] font-normal w-full mt-[3rem]">
          © {new Date().getFullYear()} ACQ, All Rights Reserved
        </div>
      </div>
      <div className="text-center bg-primaryColor py-6 font-[700] text-[#eeecec] text-xs md:text-[16px] px-10 ">
        ACQ Capital Managers Limited is registered and regulated by the
        Securities and Exchange Commission, Nigeria.
      </div>
    </>
  );
};

export default Footer;
